import BaseForm from '../base';
// import { ObjectPanelComponent } from '../components/object';
import { ObjectPanelComponent, LatLongColumnsComponent } from '../components';
export class AlarmsForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent(),
            new ObjectPanelComponent({
                label: 'Points',
                key: 'points',
            }),
            new ObjectPanelComponent({
                label: 'Triggers',
                key: 'triggers'
            }),
            {
                label: 'PollRate (ms)',
                key: 'pollRateMilliseconds',
                type: 'number',
            },
            {
                label: 'Warn Value',
                key: 'warnValue',
                type: 'number',
            },
            {
                label: 'Shutoff Delay',
                key: 'shutoffDelay',
                type: 'number',
            },
            {
                label: 'Deadband',
                key: 'deadband',
                type: 'number',
            },
        ];
    }
}
// {
//   "_id" : ObjectId("589cbe6eb7afecc63da37b72"),
//   "settings" : {
//       "points" : {
//           "pressure" : {
//               "address" : 7015,
//               "dataType" : "nodejsModbus",
//               "protocol" : "rtu",
//               "functionType" : "readHoldingReg",
//               "options" : {
//                   "slave" : 1,
//                   "baudRate" : 9600,
//                   "registerFormat" : "singleIEEE32",
//                   "device" : "/dev/ttyUSB0"
//               }
//           },
//           "HighHighCasingPressureSetpoint" : {
//               "dataType" : "const",
//               "value" : 250
//           }
//       },
//       "triggers" : {
//           "Alarm" : {
//               "expr" : "pressure > HighHighCasingPressureSetpoint",
//               "event" : "alarm"
//           }
//       },
//       "pollRateMilliseconds" : 30000,
//       "latitude" : "33.761045859106694",
//       "longitude" : "-118.21666449308395",
//       "warnValue" : 120,
//       "shutoffDelay" : 0,
//       "deadband" : 0
//   },
//   "equipmentType" : "alarms",
//   "name" : "CRC - Tidelands FY-95 - HIGH CASING PRESSURE"
// }
// {
//   "_id" : ObjectId("5924722103775d0f36db7f6f"),
//   "settings" : {
//       "points" : {
//           "otechRSSI" : {
//               "updateDelay" : 60000,
//               "address" : 7013,
//               "dataType" : "nodejsModbus",
//               "protocol" : "rtu",
//               "functionType" : "readHoldingReg",
//               "options" : {
//                   "slave" : 1,
//                   "baudRate" : 9600,
//                   "registerFormat" : "singleIEEE32",
//                   "device" : "/dev/ttyUSB0",
//                   "scalingFactor" : -1
//               }
//           },
//           "lowRSSISetpoint" : {
//               "dataType" : "const",
//               "value" : -90
//           }
//       },
//       "triggers" : {
//           "Alarm" : {
//               "expr" : "otechRSSI < lowRSSISetpoint",
//               "event" : "alarm"
//           }
//       },
//       "pollRateMilliseconds" : 60000,
//       "latitude" : "",
//       "longitude" : "",
//       "warnValue" : -90,
//       "shutoffDelay" : 0,
//       "deadband" : 0
//   },
//   "equipmentType" : "alarms",
//   "name" : "CRC - Tidelands - FY-125 - OTECH LOW RSSI -90"
// }
